<ng-container *transloco="let t; read: 'issues'">
  <p [class]="status | async" *ngIf="status | async">
    {{ t(status | async) }}
  </p>
</ng-container>
